import unmutedIcon from "./player/unmuted.svg";

const Volume = () => <img src={unmutedIcon} alt="" aria-hidden="true" />;

export default Volume
